import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

const DOC = gql`
  query Distributions(
    $scenarioId: ID!
    $appId: ID!
    $tenantId: ID!
    $zoneId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                allocationDistributionsPerFaFunctionCategory {
                  distributions {
                    name
                    amountToAllocate
                    allocations {
                      recipient {
                        id
                      }
                      percent
                      dollars
                    }
                  }
                  faFunctionCategory {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.DistributionsQuery,
    ents.extra.rate.Allocation.Distribution.OfPool.Breakdown[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'rate',
              graphql.transformers.OUT.select(
                'allocationDistributionsPerFaFunctionCategory',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    entries: {
                      usingFullInput: graphql.transformers.OUT.default(
                        graphql.transformers.OUT.select(
                          'distributions',
                          graphql.transformers.OUT.list(
                            graphql.transformers.OUT.object({
                              allocableAmount: {
                                usingFullInput:
                                  graphql.transformers.OUT.default(
                                    graphql.transformers.OUT.select(
                                      'amountToAllocate',
                                      transformers.PASS_THROUGH,
                                    ),
                                    0,
                                  ),
                              },
                              allocations: {
                                usingFullInput:
                                  graphql.transformers.OUT.default(
                                    graphql.transformers.OUT.select(
                                      'allocations',
                                      graphql.transformers.OUT.record(
                                        graphql.transformers.OUT.tuple([
                                          graphql.transformers.OUT.select(
                                            'recipient',
                                            graphql.transformers.OUT.select(
                                              'id',
                                              // TODO: why can't we use transformers.PASS_THROUGH here?
                                              graphql.transformers.OUT.custom(
                                                id => id,
                                              ),
                                            ),
                                          ),
                                          // TODO: why can't we use graphql.transformers.OUT.object here?
                                          graphql.transformers.OUT.custom(
                                            allocation => ({
                                              [ents.extra.rate.Allocation
                                                .ValueType.Percent]:
                                                TypeAsserter.validateButJustWarn(
                                                  allocation?.percent,
                                                  TypeAsserter.assertIsNotNullish,
                                                ),
                                              [ents.extra.rate.Allocation
                                                .ValueType.Currency]:
                                                TypeAsserter.validateButJustWarn(
                                                  allocation?.dollars,
                                                  TypeAsserter.assertIsNotNullish,
                                                ),
                                              // NOTE: We don't have a total statistic, and in order for our allocation
                                              // calculations to fit, we need to assume that the statistic is equal
                                              // to dollars, so that the percentages would be appropriate if this
                                              // calculation is used: percent = statistic / total statistic.
                                              // Because, for example, dollars percent = dollars / total dollars,
                                              // since that percentage fits into our calculation, the statistics
                                              // will also fit with that logic.
                                              [ents.extra.rate.Allocation
                                                .ValueType.Statistic]:
                                                TypeAsserter.validateButJustWarn(
                                                  allocation?.percent,
                                                  TypeAsserter.assertIsNotNullish,
                                                ),
                                            }),
                                          ),
                                          // graphql.transformers.OUT.object({
                                          //   [ents.extra.rate.Allocation
                                          //     .ValueType.Percent]: {
                                          //     usingFullInput:
                                          //       graphql.transformers.OUT.select(
                                          //         'percent',
                                          //         transformers.PASS_THROUGH,
                                          //       ),
                                          //   },
                                          //   [ents.extra.rate.Allocation
                                          //     .ValueType.Currency]: {
                                          //     usingFullInput:
                                          //       graphql.transformers.OUT.select(
                                          //         'dollars',
                                          //         transformers.PASS_THROUGH,
                                          //       ),
                                          //   },
                                          //   [ents.extra.rate.Allocation
                                          //     .ValueType.Statistic]: {
                                          //     usingFullInput:
                                          //       graphql.transformers.OUT.select(
                                          //         'dollars',
                                          //         transformers.PASS_THROUGH,
                                          //       ),
                                          //   },
                                          // } as transformers.Factory.object.Fields<
                                          //   transformers.Factory.OutputType<
                                          //     typeof graphql.transformers.OUT
                                          //   >,
                                          //   NonNullable<
                                          //     NonNullable<
                                          //       NonNullable<
                                          //         NonNullable<
                                          //           NonNullable<
                                          //             NonNullable<
                                          //               NonNullable<
                                          //                 NonNullable<
                                          //                   NonNullable<
                                          //                     NonNullable<
                                          //                       NonNullable<
                                          //                         graphql.schema.DistributionsQuery['tenant']
                                          //                       >['zone']
                                          //                     >['app']
                                          //                   >['scenario']
                                          //                 >['extra']
                                          //               >['rate']
                                          //             >['allocationDistributionsPerFaFunctionCategory']
                                          //           >[number]
                                          //         >['distributions']
                                          //       >[number]
                                          //     >['allocations']
                                          //   >[number],
                                          //   ents.extra.rate.Allocation
                                          // >),
                                        ]),
                                        { onNullish: 'remove' },
                                      ),
                                    ),
                                    {},
                                  ),
                              },
                              name: graphql.transformers.OUT.validate(
                                transformers.PASS_THROUGH,
                                TypeChecker.isNotNullish,
                                { warnOnly: true },
                              ),
                            }),
                            { onNullish: 'remove' },
                          ),
                        ),
                        [],
                      ),
                    },
                    id: {
                      usingFullInput: graphql.transformers.OUT.nonNull(
                        graphql.transformers.OUT.select(
                          'faFunctionCategory',
                          graphql.transformers.OUT.select(
                            'id',
                            graphql.transformers.OUT.validate(
                              transformers.PASS_THROUGH,
                              TypeChecker.isNotNullish,
                              { warnOnly: true },
                            ),
                          ),
                        ),
                        { warnOnly: true },
                      ),
                    },
                  }),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.DistributionsQuery,
  ents.extra.rate.Allocation.Distribution.OfPool.Breakdown[],
  graphql.schema.DistributionsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
